import React from "react";
import type { Node } from "react";
import HeaderCell from "sulu-admin-bundle/components/Table/HeaderCell";
import ReactTooltip from "react-tooltip";
import styles from "../../../css/table/RecapList.scss";

type Props = {|
    children?: Node,
    className?: string,
    dataTitle?: "",
    width?: "",
|};

export default class SimpleHeaderCell extends React.PureComponent<Props> {
    static defaultProps = {
        width: "auto",
        dataTitle: "",
    };

    render() {
        const uid =
            Date.now().toString(36) + Math.random().toString(36).substr(2);
        const { children, className, dataTitle, width } = this.props;

        return (
            <HeaderCell className={className} width={width}>
                <span
                    data-tip={dataTitle}
                    data-for={uid}
                    className={styles.simpleHeaderCell}
                >
                    <ReactTooltip id={uid} multiline={true} type={"info"} />
                    {children}
                </span>
            </HeaderCell>
        );
    }
}
